import type { Faq } from "@components/Faq.js";
import type { Tenant } from "@core/schema/Tenant.js";
import { getCloudSolutionsPath } from "@core/schema/paths/getCloudSolutionsPath.js";

export function getFaqsCrm(tenant: Tenant): Faq[] {
	return [
		{
			question: "Jak dlouho trvá vývoj CRM na míru?",
			answer: "První verzi zhotovíme zhruba do 3 měsíců, plnou verzi pak nejčastěji v rozmezí 6–9 měsíců.",
		},
		{
			question: "Jaké API možnosti nabízíte pro integraci CRM se specifickými aplikacemi?",
			answer: `Dokážeme CRM napojit na jakýkoliv systém třetí strany, které je v [${getCloudSolutionsPath(tenant)}][[cloudu]] a má API. U systémů, které v cloudu nejsou a API nemají to svedeme také, ale záleží i na řadě dalších detailů (např. jak funguje přenos dat).`,
		},
		{
			question: "Jaké jsou náklady na integraci CRM s dalšími aplikacemi? ",
			answer:
				"Čím modernější a kvalitnější službu integrujeme, tím je propojení systému jednodušší, a tím pádem i levnější. Provoz integračního softwaru typicky stojí od pár korun měsíčně po desítky korun měsíčně. Cena se odvíjí od aktuálního ceníku použitých služeb. Pokud je služba s API třetí strany zpoplatněná měsíčními poplatky, zahrnujeme do nákladů i tuto částku.",
		},
		{
			question: "Jak chráníte data uložená v CRM systému?",
			answer:
				"Data jsou zabezpečená díky naší ověřené implementaci s využitím služeb od Amazon Web Services (AWS). Tato služba má vyšší úroveň zabezpečení, než kdybyste CRM provozovali u lokálního poskytovatele serverů, případně na vlastním fyzickém serveru.",
		},
		{
			question: "Jak zabezpečujete ochranu přístupu k CRM?",
			answer:
				"Využíváme službu AWS Cognito pro správu uživatelských účtů, ověřování a autorizaci v aplikacích. Umožňuje snadné přihlašování, registraci a správu uživatelů bez nutnosti vytvářet vlastní autentizační systém.",
		},
		{
			question: "Pokud si od vás necháme dodat CRM systém, kolik stojí jeho provozování?",
			answer:
				"Cena se pohybuje od desítek korun měsíčně po nižší stovky korun měsíčně – opět platí, že se řídíme aktuálními ceníky AWS a dalších služeb. V každém případě platíte jen za to, co opravdu využijete.",
		},
		{
			question: "Poskytujete po implementaci CRM podporu a údržbu?",
			answer:
				"Ano, pomůžeme vám například s aktualizacemi CRM, čímž se prodlužuje životnost systému. Budeme vám k ruce také s další podporou a údržbou.",
		},
	];
}
